
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/speakers/[id]",
      function () {
        return require("private-next-pages/world/speakers/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/speakers/[id]"])
      });
    }
  